module.exports = __webpack_public_path__ + "static/img/img3.8023b30.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/shop/img3.jpg
// module id = 0J4C
// module chunks = 0